export const ADD_RECIPE_TO_MENU = 'ADD_RECIPE_TO_MENU';
export const REORDER_MENU_ITEMS = 'REORDER_MENU_ITEMS';
export const COMBINE_ITEMS = 'COMBINE_ITEMS';
export const MOVE_RECIPE = 'MOVE_RECIPE';
export const ADD_RECIPE_TO_DAYS = 'ADD_RECIPE_TO_DAYS';
export const RESET_MENU_STATE = 'RESET_MENU_STATE';
export const CYCLE_MENU_FETCHING = 'CYCLE_MENU_FETCHING';
export const CYCLE_MENU_FETCH_ERROR = 'CYCLE_MENU_FETCH_ERROR';
export const CYCLE_MENU_SAVE_SUCCESSFUL = 'CYCLE_MENU_SAVE_SUCCESSFUL';
export const DELETE_RECIPES = 'DELETE_RECIPES';
export const RECEIVED_MENU_DETAILS = 'RECEIVED_MENU_DETAILS';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const APPLY_CYCLE_MENU = 'APPLY_CYCLE_MENU';
export const APPLY_CYCLE_MENU_SUCCESS = 'APPLY_CYCLE_MENU_SUCCESS';
export const APPLY_CYCLE_MENU_ERROR = 'APPLY_CYCLE_MENU_ERROR';
export const UPDATE_RECIPE_PROJECTED_SERVINGS =
  'UPDATE_RECIPE_PROJECTED_SERVINGS';
export const ANALYZE_CYCLE_MENU_ERROR = 'ANALYZE_CYCLE_MENU_ERROR';
export const SET_WEEKLY_REQUIREMENTS = 'SET_WEEKLY_REQUIREMENTS';
export const SET_UNMET_DAILY_REQUIREMENTS = 'SET_UNMET_DAILY_REQUIREMENTS';
export const SET_DAILY_CONTRIBUTIONS = 'SET_DAILY_CONTRIBUTIONS';
export const ANALYZING_CYCLE_MENU = 'ANALYZING_CYCLE_MENU';
export const CHANGE_RECIPE_DISPLAY_ON_CALENDAR =
  'CHANGE_RECIPE_DISPLAY_ON_CALENDAR';
export const UPDATE_RECIPE_QTY_OF_PORTION = 'UPDATE_RECIPE_QTY_OF_PORTION';
export const UPDATE_RECIPE_SERVINGS_PERCENTAGE =
  'UPDATE_RECIPE_SERVINGS_PERCENTAGE';
export const TOGGLE_RECIPE_ALACARTE = 'TOGGLE_RECIPE_ALACARTE';
export const REMOVE_RECIPE_CHILD = 'REMOVE_RECIPE_CHILD';
export const CYCLE_MENU_SWITCH_VIEW = 'CYCLE_MENU_SWITCH_VIEW';
export const DISABLE_DELETE_RECIPE = 'DISABLE_DELETE_RECIPE';
export const ADD_REIMB_MEAL = 'ADD_REIMB_MEAL';
export const ADD_RECIPE_TO_REIMB_MEALS = 'ADD_RECIPE_TO_REIMB_MEALS';
export const MOVE_REIMB_MEAL_RECIPE = 'MOVE_REIMB_MEAL_RECIPE';
export const UPDATE_REIMB_MEAL_CONTRIBUTION = 'UPDATE_REIMB_MEAL_CONTRIBUTION';
export const ADD_RECIPE_TO_REIMB_MEAL = 'ADD_RECIPE_TO_REIMB_MEAL';
export const REMOVE_RECIPE_FROM_REIMB_MEALS = 'REMOVE_RECIPE_FROM_REIMB_MEALS';
export const REPLACE_RECIPES = 'REPLACE_RECIPES';
export const GET_SCHOOL_CALENDAR = 'GET_SCHOOL_CALENDAR';
export const GET_CYCLE_MENU_SITES = 'GET_CYCLE_MENU_SITES';



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/editmenu/types.js